// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.small-datepicker[data-v-d449b1da] {\r\n  width: 120px !important; /* Reduce width */\r\n  font-size: 12px; /* Adjust text size */\n}\r\n", ""]);
// Exports
module.exports = exports;
